
export class SelectMenu {
  constructor() {
    if(document.querySelector('#menu-style-1-select')) {
      document.querySelector('#menu-style-1-select').onchange = function() {
        document.querySelector('#menu-style-1-select-form').submit(); 
      }
    }
  }
}
